import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { T } from '../../helpers/i18n';
import { AssigneePicker, CommonFormField } from '../../components';
import { useRfiForm } from '../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { Assignee } from '../../sdk';
import { RfiCreateFormValues } from '../types';
import { useOxygen } from '../../providers/OxygenProvider';
import { useProjectAssignees } from '../../hooks/useProjectAssignees';

const FIELD_NAME = ISSUE_ATTRIBUTE_NAMES.WATCHERS;

export const Watchers = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const isFieldsMandatory = mandatoryFields.includes(FIELD_NAME);
  const errorMessage = formik.touched[FIELD_NAME] && formik.errors[FIELD_NAME];
  const oxygen = useOxygen();
  const { allProjectAssignees } = useProjectAssignees();

  const handleSelectAssignee = (assignees: Assignee[]) => {
    formik.setFieldValue(FIELD_NAME, assignees);
  };

  const selectedAssignees = formik.values[FIELD_NAME];

  // If the selected assignees are not in the list of available assignees, remove them.
  // This can happen when the assignee is prefilled by rfi-type but the assignee is no longer valid.
  useEffect(() => {
    const validAssignees = selectedAssignees.filter((assignee) =>
      allProjectAssignees.some((option) => option.id === assignee.id),
    );

    if (validAssignees.length !== selectedAssignees.length) {
      handleSelectAssignee(validAssignees);
    }
  }, [selectedAssignees, allProjectAssignees]);

  return (
    <CommonFormField
      label={T.translate('new.watchers')}
      required={isFieldsMandatory}
      error={isFieldsMandatory && errorMessage}
      ref={refs[FIELD_NAME]}
    >
      <AssigneePicker
        onChange={handleSelectAssignee}
        selectedAssignees={selectedAssignees}
        assigneesOptions={allProjectAssignees}
        clearable
        disabled={isSubmitting}
        error={!!errorMessage}
      />
    </CommonFormField>
  );
};
